import React from 'react';

/**
 * A quiet colophon: the school's name, the year, the legal links and a small
 * AtadaBoard credit. A hairline separates it from the page instead of a slab of
 * dark colour.
 */
const SchoolProfileFooter = ({ schoolName }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="sp-colophon">
      <div className="sp-shell sp-colophon-inner">
        <p className="sp-colophon-school">
          {schoolName}
          <span className="sp-colophon-year"> · {currentYear}</span>
        </p>

        <nav className="sp-colophon-links" aria-label="Legal">
          <a className="sp-inline-link" href="/privacy">
            Privacy
          </a>
          <a className="sp-inline-link" href="/terms">
            Terms
          </a>
        </nav>

        <p className="sp-colophon-credit">
          Powered by{' '}
          <a
            className="sp-inline-link"
            href="https://atadaboard.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            AtadaBoard
          </a>
        </p>
      </div>

      <style>{`
        .sp-colophon {
          border-top: 1px solid var(--sp-rule);
          background: var(--sp-paper-raised);
        }

        .sp-colophon-inner {
          padding-top: 2rem;
          padding-bottom: 2rem;
          display: flex;
          align-items: baseline;
          justify-content: space-between;
          gap: 1rem 2rem;
          flex-wrap: wrap;
        }

        .sp-colophon-school {
          margin: 0;
          font-family: var(--sp-display);
          font-size: 1.05rem;
          font-weight: 600;
          letter-spacing: -0.01em;
          color: var(--sp-ink);
        }

        .sp-colophon-year {
          color: var(--sp-ink-muted);
          font-variant-numeric: tabular-nums;
        }

        .sp-colophon-links {
          display: flex;
          gap: 1.5rem;
          font-size: 0.9rem;
        }

        .sp-colophon-credit {
          margin: 0;
          font-size: 0.85rem;
          color: var(--sp-ink-muted);
        }

        @media (max-width: 700px) {
          .sp-colophon-inner {
            flex-direction: column;
            align-items: flex-start;
            gap: 1rem;
          }
        }
      `}</style>
    </footer>
  );
};

export default SchoolProfileFooter;
